import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsRoute: InvariantJiraRoute = {
	name: 'software-reports',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports',
};
